module.exports = __webpack_public_path__ + "static/media/03_quote_tablet.d7ce6011.jpg";